import classNames from 'classnames';

interface ActivtiyRootProps {
  title: string;
  fullWidth: boolean;
  onClick: (e: React.MouseEvent) => void;
}
export function ActivityRoot(props: ActivtiyRootProps) {
  const { title, fullWidth, onClick } = props;
  return (
    <div className="flex items-center">
      <div
        data-cy="notif-activity-root"
        onClick={onClick}
        className={classNames(
          'text-neutral-400 font-semibold max-w-[114px] truncate text-nowrap px-1',
          'cursor-pointer rounded-md',
          'transition-colors duration-200',
          'hover:bg-neutral-200 hover:text-neutral-500',
          {
            'max-w-[171px]': fullWidth,
            'max-w-[114px]': !fullWidth,
          }
        )}
      >
        {title}
      </div>
    </div>
  );
}
